import React from "react";

import withSessionHandling from "@/context/auth/withSessionHandling";
import AppUpdateScreen from "@/screens/Settings/Troubleshooting/AppUpdateScreen";

function Page(): React.JSX.Element {
  return <AppUpdateScreen />;
}

export default withSessionHandling(Page);
